// Menu Close Trigger
document.querySelector('.trigger-close').addEventListener('click', function() {
    var menuIcon = document.querySelector('.header__icon--menu');
    if (menuIcon) {
        var event = new Event('click');
        menuIcon.dispatchEvent(event);
    }
});
// END Menu Close Trigger

// Collection product item add to cart
function addItemCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      
    },
    error: function(response) {
        alert(response);
    }
  });
}

jQuery(document).on('click','.add__btn_custom_button',function(){
  var variantId = jQuery(this).attr('data-vid');
  $(this).hide();
  $(this).parent().find('.add__custom_loader').show();
  $(this).val('');
  addItemCart(1,variantId);
  setTimeout(function(){
    $('.add__btn_custom_button').show();
    $('.add__custom_loader').hide();
  },1550);
});
// END Collection product item add to cart

// Advance collapsible
$(document).ready(function() {
  $(".collapsible-panel > .collapsible-panel-heading").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".collapsible-panel-content")
        .slideUp(200);
      $(".collapsible-panel > .collapsible-panel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".collapsible-panel > .collapsible-panel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".collapsible-panel > .collapsible-panel-heading").removeClass("active");
      $(this).addClass("active");
      $(".collapsible-panel-content").slideUp(200);
      $(this)
        .siblings(".collapsible-panel-content")
        .slideDown(200);
    }
  });
});
// END :: Advance collapsible

// LOGO MARQUEE
$('.logo_marquee_slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
      }
    },
  ]
});
// END :: LOGO MARQUEE
// PRODUCT GALLERY SLIDER WITH LIGHTBOX
$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: false,
    dots: false,
    draggable: false,
    focusOnSelect: false,
});
$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: false,
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1
        }
      }
    ]
});

$(".product---gallery-v1").find(".product__gallery").slickLightbox({
  src: 'src',
  itemSelector: '.js-gallery-popup img',
  background: 'rgba(0, 0, 0, .7)'
});

$(".zoom-gallery").click(function () {
  $(".product__gallery .slick-current .js-gallery-popup").trigger("click");
});

// END :: PRODUCT GALLERY SLIDER WITH LIGHTBOX

// WHAT IS THE BERRY ? MENU
document.addEventListener('DOMContentLoaded', function() {
  var videoLinkId = 'dj1F1eEbjJw';
  var videoLinkText = 'WHAT IS THE BERRY?';
  var videoLinkTextMobile = 'What is the Berry?';
  var videoFooterLinkText = 'How It Works';
  var popupVideo = `
    <div class="video-popup-wrapper" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.8);z-index:10000;">
      <div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);width:80%;max-width:800px;">
        <div style="position:relative;padding-bottom:56.25%;">
          <iframe id="video-iframe" width="100%" height="100%" src="https://www.youtube.com/embed/${videoLinkId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;"></iframe>
        </div>
        <button type="button" style="position:absolute;top:0;right:0;background-color:rgba(0,0,0,0.8);color:white;font-size:20px;border:none;padding:5px 10px;cursor:pointer;" onclick="stopVideoAndClosePopup();">X</button>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', popupVideo);
  var videoPopupWrapper = document.querySelector('.video-popup-wrapper');
  var videoIframe = document.getElementById("video-iframe");
  var navItems = document.querySelectorAll('header nav li a');
  navItems.forEach(function(navItem) {
    if (navItem.innerText.trim() === videoLinkText) {
      navItem.href = 'javascript:void(0)';
      navItem.addEventListener('click', function() {
        videoPopupWrapper.style.display = 'block';
      });
    }
  });
  var navItemsMobile = document.querySelectorAll('.menu-drawer__navigation ul li a');
  navItemsMobile.forEach(function(navItemm) {
    if (navItemm.innerText.trim() === videoLinkTextMobile) {
      navItemm.href = 'javascript:void(0)';
      navItemm.addEventListener('click', function() {
        videoPopupWrapper.style.display = 'block';
      });
    }
  });
  
  var navFooterItems = document.querySelectorAll('.footer__blocks-wrapper .footer-block--menu ul li a');
  navFooterItems.forEach(function(navItem) {
    if (navItem.innerText.trim() === videoFooterLinkText) {
      navItem.href = 'javascript:void(0)';
      navItem.addEventListener('click', function() {
        videoPopupWrapper.style.display = 'block';
      });
    }
  });
  window.stopVideoAndClosePopup = function() {
    videoPopupWrapper.style.display = 'none';
    videoIframe.src = videoIframe.src;
  };
});
// END :: WHAT IS THE BERRY ? MENU

// CART PROGRESS
var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
setInterval(function(){
 if(jQuery('.drawer.active').length>0){
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      console.log("totalCart",totalCart);
      if(cartData.length>0){
        subTotal = cart.original_total_price;
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
      
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
        }else{
          jQuery('.cart_shipping_box').hide();
        }
        
      
        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += Shopify.formatMoney(goalPendingAmount);
          tempStr += '</span>'
          tempStr += goalAfterText;
        }
        else{
          tempStr += goalReachText;
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }
});
 }
},1000);
// END :: CART PROGRESS

var drawerInterval='';
jQuery(document).ready(function(){
  drawerInterval =setInterval(function(){
    if(jQuery('#CartDrawerMain').hasClass('active')){
      if(jQuery('.cart_look_productbox ').attr('display')=='block' || jQuery('.cart_look_productbox ').attr('display')==undefined){
        var upsellCount =  jQuery('.cart_look_productbox ').find('.upsell--item').length;
        var displayUpsell=0;
        jQuery('.cart_look_productbox ').find('.upsell--item').each(function(){
          if(jQuery(this).css('display')=='none'){
            displayUpsell++;
          }
        });  
        if(displayUpsell==upsellCount){
          jQuery('.cart_look_productbox ').hide();
        }else{
          jQuery('.cart_look_productbox ').show();
        }
      }
    }
  },1000);
});